// Beneficiary designation (Beneficiary Designation). Multi-beneficiary support with 100%-sum
// enforcement per tier is provided by BeneficiariesPanel.
import React from 'react';
import { BeneficiariesPanel } from '@/components/profile/BeneficiariesPanel';

export const BeneficiariesPage = () => {
  return (
    <div className="space-y-4" data-testid="beneficiaries-page">
      <div className="flex items-center justify-between">
        <h1
          className="text-lg font-semibold text-[#1B2A4A]"
          style={{ fontFamily: 'IBM Plex Sans' }}
        >
          Beneficiary Designation (Beneficiary Designation)
        </h1>
      </div>
      <BeneficiariesPanel />
    </div>
  );
};
